import React from 'react'
import styled from 'styled-components'
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined'
import { openHelp } from './helpEvents'

const HelpButton = ({ compact = false }) => (
  compact ? (
    <IconOnly type='button' onClick={openHelp} aria-label='Guide me: step-by-step guides' title='Guide me: step-by-step guides'>
      <ExploreOutlinedIcon />
    </IconOnly>
  ) : (
    <Labelled type='button' onClick={openHelp} title='Step-by-step guides on your own screens (press ?)'>
      <ExploreOutlinedIcon style={{ fontSize: 18 }} aria-hidden='true' />
      <span>Guide me</span>
    </Labelled>
  )
)

export default HelpButton

const Labelled = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  padding: 0 14px;
  margin-right: 8px;
  border: 1px solid #33becc;
  border-radius: 22px;
  background: #fff;
  color: #0C1229;
  font: inherit;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  svg { color: #2aa6b3; }
  &:hover { background: #e6f7f9; }
  &:focus-visible { outline: 2px solid #33becc; outline-offset: 2px; }
`

const IconOnly = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #2aa6b3;
  cursor: pointer;
  &:focus-visible { outline: 2px solid #33becc; outline-offset: 2px; }
`
